<template>
  <div class="page-main">
    <van-nav-bar
      class="nav-bar"
      fixed
      title="消息通知"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <div class="content">
      <MdScroll
        class="mescroll"
        :url="url"
        :filterData="filterData"
        :fetchList="fetchList"
        @getList="getList"
      >
        <div
          class="item"
          v-for="item in list"
          :key="item.Id"
        >
          <div class="header">
            <div class="item-icon">
              <van-icon
                class="base-icon"
                name="bell"
                size="20"
              />
            </div>
            <div class="item-content">
              <p class="text-big">消息通知</p>
              <p class="text-normal text-bold">[{{item.Type | notice-type}}]{{ item.Title }}</p>
              <p class="text-small text-gray">{{item.CreateTime | datetime-parse}}</p>
              <div
                v-if="item.articleInfo && item.Type !== 4"
                class="article-item"
                @click="handleClick(item.articleInfo.Id)"
              >
                <LazyImg
                  class="article-img"
                  :imgUrl="item.articleInfo.CoverImage"
                ></LazyImg>
                <span>{{item.articleInfo.Title}}</span>
              </div>
            </div>
          </div>
        </div>
        <EmptyPosition v-show="!list.length" type="notice"></EmptyPosition>
      </MdScroll>
    </div>
  </div>
</template>

<script>
import EmptyPosition from '@/components/common/emptyPosition'
import LazyImg from "@/components/lazyImg";
import MdScroll from "@/components/mdScroll/mdScroll";
import commonMix from "@/mixins/commonMix";
import { Cms } from "@/api";
export default {
  name: "noticeList",
  components: { MdScroll, LazyImg, EmptyPosition },
  mixins: [commonMix],
  data() {
    return {
      url: Cms.NoticeQueryByPage,
      list: [],
      filterData: {
        Type: 0,
        UserId: this.$mdUtils.getUserInfo("Id"),
        PageIndex: 1,
        PageSize: 10
      }
    };
  },
  methods: {
    handleClick(id) {
      this.$router.push({ name: 'detail', query: { id } });
    },
    fetchList(list) {
      this.getArticleInfo(list);
    },
    getList(list, newList) {
      this.list = list;
      this.setRead(newList);
    },
    setRead(list) {
      let Ids = [];
      list.forEach(item => {
        if (!item.IsRead) Ids.push(item.Id);
      });
      Ids.length && this.$api(Cms.NoticeMultiSetRead, { Ids });
    },
    getArticleInfo(list) {
      let Ids = [];
      list.forEach(item => {
        if (
          (item.Type === 3 ||
            item.Type === 5 ||
            item.Type === 6 ||
            item.Type === 10 ||
            item.Type === 11 ||
            item.Type === 16) &&
          item.RelId
        ) {
          Ids.push(item.RelId);
        }
      });
      if (Ids.length) {
        this.$api(Cms.ArticleQueryByPage, {
          Ids: Array.from(new Set(Ids)),
          PageSize: Ids.length
        }).then(res => {
          list = list.map(item => {
            let tag = res.List.find(subItem => item.RelId === subItem.Id);
            tag && this.$set(item, "articleInfo", tag);
            return item;
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-bar {
  min-height: 46px;
}
.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 46px;
  bottom: 0;
}
.mescroll {
  top: 46px;
}

.item {
  padding: 25px;
  border-bottom: 1px solid $gray;
}

.header {
  display: flex;
  align-items: flex-start;
}

.item-icon {
  position: relative;
  width: 100%;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(43, 50, 63, 1);
  border-radius: 50%;
  flex: none;
  .base-icon {
    @include content-center;
  }
}
.item-content {
  flex: 1;
  overflow: hidden;
  margin-left: 15px;
  .article-item {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;
    background: $gray;
    padding: 10px;
  }
  .article-img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    flex: none;
  }
  p {
    margin: 0 0 5px;
    @include text-overflow();
  }
}
</style>

